import * as React from 'react';
import { IconChevronRight16 } from '@cian/ui-kit';
import { debounce } from 'throttle-debounce';
import classNames from 'classnames';

import * as style from './NextButton.css';
import { TABLE_SCROLL_BUTTON_DELAY } from '../../constants/delays';

export interface INextButtonProps {
  last: boolean;
  sticky: boolean;
  onClick: () => void;
}

export const NextButton = ({ last, onClick, sticky }: INextButtonProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleClick = React.useCallback(debounce(TABLE_SCROLL_BUTTON_DELAY, onClick), [onClick]);

  if (last) {
    return null;
  }

  return (
    <div
      onClick={debouncedHandleClick}
      className={classNames(style['container'], sticky && style['container--sticky'])}
    >
      <IconChevronRight16 color={'white_100'} />
    </div>
  );
};
